module.exports = __webpack_public_path__ + "static/media/etat-alert-red.a51f1100.svg";